// This file was auto-generated by Fern from our API Definition.
export var SimpleWorkflowDataInput;
(function (SimpleWorkflowDataInput) {
    SimpleWorkflowDataInput.Runtime = {
        Python: "python",
        Typescript: "typescript",
        Javascript: "javascript",
    };
})(SimpleWorkflowDataInput || (SimpleWorkflowDataInput = {}));
